var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlide3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 206.19 146.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2 {\n        fill: #fff;\n        opacity: 0;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 37.18,
    y1: 147.15,
    x2: 164.02,
    y2: 20.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00ffed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0cffed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#2dfff0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#62fff3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#acfff9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 206.19,
    height: 146.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.67,84.07h12.5l14.47,26.01,14.34-26.01h12.37v33.56h-8.12l.32-27.73h-.13l-15.23,27.73h-7.42l-15.16-27.73h-.13l.32,27.73H7.67v-33.56ZM80.26,84.07h10.28l18.4,33.56h-9.64l-4.31-8.31h-19.42l-4.25,8.31h-9.39l18.4-33.56h-.06ZM92.37,104.06l-7.04-14.15-7.17,14.15h14.21ZM126.38,100.38l-16.81-16.24h10.79l11.36,11.67,11.55-11.67h10.47l-16.88,16.24,16.88,17.32h-10.98l-11.23-12.37-11.29,12.37h-10.66l16.81-17.32h0ZM171.18,100.38l-16.81-16.24h10.79l11.36,11.67,11.55-11.67h10.47l-16.88,16.24,16.88,17.32h-10.98l-11.23-12.37-11.29,12.37h-10.66l16.81-17.32h0ZM32.34,29.24c5.58,0,16.75,1.02,17.72,11.52h-8.22c-.25-2.79-2.79-5.84-9.14-5.84-5.08,0-8.43,1.57-8.43,4.97,0,8.53,27,.36,27,15.84,0,9.34-9.7,11.78-17.41,11.78-13.05,0-18.27-5.13-18.38-12.74h8.22c.2,4.77,4.16,7.06,10.41,7.06,4.62,0,8.93-1.37,8.93-5.33,0-8.98-26.7-1.17-26.7-16.04,0-8.07,7.16-11.22,15.99-11.22ZM54.97,39.6h7.01v3.86h.1c2.08-3.25,6.09-4.57,10.3-4.57,10.25,0,14.72,7.46,14.72,14.26s-4.47,14.37-14.72,14.37c-5.58,0-9.8-3.1-10.3-4.72h-.1v13.96h-7.01v-37.16ZM61.67,53.15c0,4.57,2.49,8.98,9.04,8.98s9.09-4.42,9.09-8.98-2.49-8.88-9.09-8.88-9.04,4.42-9.04,8.88ZM119.43,60.36c0,1.47,1.07,1.52,1.52,1.52.66,0,1.73-.05,2.28-.15v4.92c-1.37.25-2.59.61-4.97.61-4.57,0-5.08-2.44-5.28-3.45-1.37,1.32-4.77,3.71-12.64,3.71-7.01,0-10.96-3.15-10.96-8.43,0-7.41,7.61-8.07,12.08-8.48,10.05-.96,11.12-1.32,11.12-3.4,0-3.1-3.55-3.86-7.61-3.86-4.62,0-7.11,1.47-7.36,4.47h-6.85c1.02-7.06,6.24-9.24,14.21-9.24,14.06,0,14.47,5.53,14.47,9.04v12.74ZM112.42,53.1c-2.03.86-4.21,1.12-9.19,1.68-5.28.61-6.55,1.78-6.55,4.06,0,3.55,3.25,4.21,5.63,4.21,3.76,0,10.1-1.42,10.1-7.36v-2.59ZM148.03,49.04c-.51-2.79-3.45-5.08-7.46-5.08-6.5,0-9.34,4.42-9.34,9.09s2.54,9.09,8.58,9.09c5.43,0,6.9-2.13,8.38-5.94h7.31c-1.62,11.17-13.05,11.32-14.92,11.32-12.03,0-16.65-7.06-16.65-14.47,0-8.68,6.24-14.47,16.65-14.47,4.06,0,13.3,1.37,14.77,10.46h-7.31ZM165.33,54.82c.15,2.99,2.18,7.61,9.14,7.61,4.62,0,6.65-1.62,8.02-3.86h7.61c-1.52,2.99-5.18,8.93-15.43,8.93-12.13,0-16.65-7.06-16.65-14.21,0-8.98,6.65-14.72,16.19-14.72,11.93,0,16.5,7.36,16.5,15.23v1.02h-25.38ZM183.4,50.36c-.86-5.38-5.63-7.01-9.09-7.01-3.25,0-7.82,1.52-8.98,7.01h18.07Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide3);
export default __webpack_public_path__ + "static/media/slide3.56bcd9ffdf3fd0c2629bd0000a4bc7ee.svg";
export { ForwardRef as ReactComponent };